import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { SecondaryButton } from '../Button';
import Infotip from '../Tooltip';
import rawRing from '../../images/raw-ring.png';
import { brandBody } from '../../content/about';

interface Props {
  expanded: boolean;
  onToggle: () => void;
}

const TheBrand = ({ expanded, onToggle }: Props) => {
  const paragraphs = expanded ? brandBody : [brandBody[0]];

  return (
    <Container id="the-brand" sx={{ mt: 4, justifyContent: 'center', display: 'flex' }} maxWidth={false}>
      <Grid container maxWidth='90%' alignItems='center' display='flex' justifyContent='center'>
        <Grid size={12}>
          <Box component="img" src={rawRing} alt='raw-peg-spring' data-testid="about-product-image" sx={{ width: '100%', height: 'auto', borderRadius: '10%' }} />
        </Grid>
        <Grid size={12} >
          <Grid display={'flex'} justifyContent={'center'}>
            <Typography variant="h4" component="h2" data-testid="about-product-title" gutterBottom fontSize={{xs: '2rem', md: '3rem'}} pb={2}>
              iets'ene ke eng
              <Infotip title="Meaning: What is iets'ene?"/>
            </Typography>
          </Grid>
          <Grid size={12} pb={2}>
            {paragraphs.map((text, i) => (
              <Typography key={i} variant='body1' fontSize={{xs: '1.1rem', md: '2rem'}} align={'center'} gutterBottom>
                {text}
              </Typography>
            ))}
          </Grid>
          <Grid size={12} display={'flex'} justifyContent={'center'}>
            <SecondaryButton
              sx={{ fontSize: { xs: '1rem', md: '1.8rem' } }}
              onClick={onToggle}
            >
              {expanded ? 'Show less' : 'Read more'}
            </SecondaryButton>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TheBrand;